import(/* webpackMode: "eager" */ "/builds/sympla/comprador/discovery-next/src/app/eventos/error.tsx");
